export default __webpack_public_path__ + "static/media/ic-copy.3c683700.svg";